import React from "react";
import { useCms } from "../context/CmsContext";

// variant: "header" (banner horizontal) or "mark" (carré, pour pied de page)
export default function Logo({ variant = "header", className, alt = "Vecteurs Conseil" }) {
    const cms = useCms();
    const defaultSrc = variant === "mark" ? "/assets/logo.png" : "/assets/logo-header.png";
    const key = variant === "mark" ? "logo.mark" : "logo.header";
    const src = cms.get(key, defaultSrc);
    const cls = className || (variant === "mark" ? "h-16 w-auto" : "h-10 w-auto");
    return <img src={src} alt={alt} className={cls} draggable={false} />;
}
